<template>
  
</template>

<script>
export default {

}
</script>

<style>

</style>
<script>
import { getPin } from "@/api/card";
export default {
  computed: {
    device() {
      return this.$store.state.app.device;
    },
    username(){
      return this.$store.state.user.fullname;
    }
  },
  data(){
    return {
      cardID: ""
    }
  },
  methods:{

    openDialog(cardID){
      this.cardID = cardID;
      this.$confirm('This will GET PIN. Continue?', 'Confirm', {
          confirmButtonText: 'GET PIN',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.submitGetPin();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Get PIN canceled'
          });          
        });
    },

    submitGetPin(){
       getPin(this.cardID).then(({result, data}) =>{
        if(result){
          this.$notify({
            title: 'Success',
            message: `Get PIN successfully`,
            type: 'success',
            duration: 2000
          });

          this.$alert(`<h2>${data.pin}</h2>`, 'Your Card PIN', {
            confirmButtonText: 'OK',
            dangerouslyUseHTMLString: true
          });
          
        }
      })
    },
    handleClose(){
      this.dialogShow = false
    }
  }
}
</script>

<style>

</style>